import { getPrivateApi } from "../lib/axiosConfig";
import { Invoice } from "../types/invoices.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/invoices";

export const getInvoicesByFleet = async (fleetId: string): Promise<Invoice[]> => {
  try {
    const { data } = await api.get(`${endpoint}/fleet/${fleetId}`);
    return data;
  } catch (error: any) {
    console.error("Erro ao buscar faturas da frota:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao buscar faturas.";
    throw new AppError(message, error.status);
  }
};

export const payInvoice = async (invoiceId: string): Promise<Invoice> => {
  try {
    const { data } = await api.put(`${endpoint}/${invoiceId}/pay`);
    return data;
  } catch (error: any) {
    console.error("Erro ao confirmar pagamento da fatura:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao confirmar pagamento.";
    throw new AppError(message, error.status);
  }
};
